// Shared formatting helpers for the Active Fires ("Hot spots") panel.
// Output looks like: "Mon 5 Oct · 10:00"

export const getLocale = (lang) => (lang?.startsWith("fr") ? "fr-FR" : "en-GB");

const stripDot = (s) => s.replace(/\.$/, "");

export const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatWeekday = (date, lang) =>
  stripDot(date.toLocaleDateString(getLocale(lang), { weekday: "short" }));

export const formatDayMonth = (date, lang) => {
  const locale = getLocale(lang);
  const day = date.toLocaleDateString(locale, { day: "numeric" });
  const month = stripDot(date.toLocaleDateString(locale, { month: "short" }));
  return `${day} ${month}`;
};

export const formatTime = (date, lang) =>
  date.toLocaleTimeString(getLocale(lang), {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });

export const formatStamp = (date, lang) =>
  `${formatWeekday(date, lang)} ${formatDayMonth(date, lang)} · ${formatTime(date, lang)}`;